import Navbar from "../components/Navbar";
import PresentacionConstructora from "../components/PresentacionConstructora";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Apartments from "../components/Apartments";
import Disponibilidad from "../components/Disponibilidad";
import Galeria from "../components/Galeria";
import QuienesSomos from "../components/QuienesSomos";
import Organigrama from "../components/Organigrama";
import Amenidades from "../components/Amenidades";
import Hipoteca from "../components/Hipoteca";
import Mapa from "../components/Mapa";
import Contacto from "../components/Contacto";
import InstagramSection from "../components/InstagramSection";
import ReservaForm from "../components/ReservaForm";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <Navbar />

      <PresentacionConstructora />

      <Hero />

      <Features />

      <Apartments />

      <Disponibilidad />

      <Galeria />

      <QuienesSomos />

      <Organigrama />

      <Amenidades />

      <Hipoteca />

      <Mapa />

      <Contacto />

      {/* Sección de Instagram */}
      <InstagramSection />

      {/* Formulario de Reserva */}
      <ReservaForm />

      {/* Pie de página */}
      <Footer />
    </>
  );
}

export default Home;